import React, {Component} from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Input, Label} from 'reactstrap'
import moment from 'moment'
import {Mutation} from 'react-apollo'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import AUSelectGenerator from "../auto_updaters/Select";
import MUTATION from '../../../queries/server/mutations/export_scheduler_mutation'

const OfficeSelect = AUSelectGenerator('offices', 'id description', 'id', ['description'])


export default class ExportModal extends Component {


    state = {
        startDate: moment().startOf('month').format('YYYY-MM-DD'),
        endDate: moment().endOf('month').format('YYYY-MM-DD'),
        officeId: undefined,
        exporting: false
    }

    dataChanged = (key, value) => {
        let data = {...this.state}
        data[key] = value
        this.setState(data)
    }

    render() {

        return (
            <Mutation mutation={MUTATION} variables={this.state}>
                {go => (<Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
                    <ModalHeader toggle={this.props.toggle}>
                        Export
                    </ModalHeader>
                    <ModalBody>
                        <Form>
                            <FormGroup>
                                <Label>Start Date</Label>
                                <Input
                                    size="sm"
                                    type="date"
                                    value={this.state.startDate}
                                    onChange={(evt) => this.dataChanged('startDate', evt.target.value)}
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label>End Date</Label>
                                <Input
                                    size="sm"
                                    type="date"
                                    value={this.state.endDate}
                                    onChange={(evt) => this.dataChanged('endDate', evt.target.value)}
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label>Office</Label>
                                <OfficeSelect
                                    size="sm"
                                    defaultLabel="All Offices"
                                    value={this.state.officeId}
                                    onChange={(office_id) => this.dataChanged('officeId', office_id)}
                                />
                            </FormGroup>
                        </Form>
                    </ModalBody>
                    <ModalFooter>

                        <Button size="sm" color="primary" disabled={this.state.exporting} onClick={() => {
                            this.setState({exporting: true})
                            go()
                                .then((res) => {
                                    console.log(res)
                                    this.setState({exporting: false})
                                    this.props.onClose()
                                    this.props.onExported(res.data.exportScheduler)
                                })
                        }}>
                            <FontAwesomeIcon
                                color="#fff"
                                icon="file-export"/>{' '}
                                {this.state.exporting ? 'Exporting...' : 'Export'}
                            </Button>
                    </ModalFooter>
                </Modal>)}
            </Mutation>
        )

    }

}